var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsSecurityInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9998 22.5C44.9998 21.0956 44.8711 19.7212 44.625 18.388L37.2716 11.0347L7.72803 34.6495L17.5271 44.4486C19.1268 44.8095 20.791 45 22.4998 45C34.9262 45 44.9998 34.9264 44.9998 22.5Z",
    fill: "#FFA300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2716 34.6495H7.72803V15.6501L20.2548 13.8099L37.2716 15.6501V34.6495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2718 15.65L22.5 11.3102V34.6494H37.2718V15.65Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72803 11.0347H37.2716V15.6501H7.72803V11.0347Z",
    fill: "#4A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.0347H37.2718V15.6501H22.5V11.0347Z",
    fill: "#0053BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.264 14.8027C11.0705 14.8027 11.7243 14.1489 11.7243 13.3424C11.7243 12.5359 11.0705 11.8821 10.264 11.8821C9.45751 11.8821 8.80371 12.5359 8.80371 13.3424C8.80371 14.1489 9.45751 14.8027 10.264 14.8027Z",
    fill: "#A3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1297 14.8027C14.9362 14.8027 15.59 14.1489 15.59 13.3424C15.59 12.5359 14.9362 11.8821 14.1297 11.8821C13.3232 11.8821 12.6694 12.5359 12.6694 13.3424C12.6694 14.1489 13.3232 14.8027 14.1297 14.8027Z",
    fill: "#A3D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0948 34.3328L22.4998 39.7183L15.9049 34.3328C14.6361 33.2967 13.9097 31.8083 13.9097 30.2448V20.2734L22.4998 17.0125L31.09 20.2734V30.2448C31.09 31.8083 30.3636 33.2967 29.0948 34.3328Z",
    fill: "#1DD882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 39.7183L29.095 34.3328C30.3638 33.2967 31.0902 31.8083 31.0902 30.2448V20.2734L22.5 17.0125V39.7183Z",
    fill: "#06B26B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6118 33.2295C25.7203 33.2295 28.2403 30.7096 28.2403 27.6011C28.2403 24.4926 25.7203 21.9727 22.6118 21.9727C19.5033 21.9727 16.9834 24.4926 16.9834 27.6011C16.9834 30.7096 19.5033 33.2295 22.6118 33.2295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.612 21.9727C22.5723 21.9727 22.5395 21.9729 22.5 21.9737V33.2284C22.5395 33.2292 22.5723 33.2294 22.612 33.2294C25.7205 33.2294 28.2404 30.7095 28.2404 27.601C28.2404 24.4926 25.7205 21.9727 22.612 21.9727Z",
    fill: "#E9EDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7444 30.9799L18.8379 28.0732L20.7023 26.2088L21.7444 27.2509L24.8145 24.1809L26.6789 26.0453L21.7444 30.9799Z",
    fill: "#079E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8143 24.1809L22.5 26.4952V30.2242L26.6788 26.0453L24.8143 24.1809Z",
    fill: "#057740"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsSecurityInfo);
export default __webpack_public_path__ + "static/media/WHSSecurityInfo.22884985da363df85c1a55dfdf1ca456.svg";
export { ForwardRef as ReactComponent };